export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "ACCOUNT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account"])},
        "ADMINISTRATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration"])},
        "USER_MANAGEMENT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Management"])},
        "CREATE_MENU": {
          "TITLE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create new"])},
          "IMPORT": {
            "TITLE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import"])}
          }
        },
        "DIRECTORY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Directory"])},
        "HELP_CENTER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resource Center"])},
        "HOME": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
        "QUICK_SEARCH": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quick search"])},
        "RECENT_BRIEFS": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Recent ", _interpolate(_named("Briefs"))])},
        "SETTINGS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
        "SIGN_OUT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign out"])},
        "WORKSPACE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Workspace"])}
      }
    }
  })
}
